module.exports = __webpack_public_path__ + "img/wheat_ns11268.cb30194e.jpg";